export default class Faq {
    constructor() {
        this.section = document.querySelector('.component-faq');
        this.questions = this.section.querySelectorAll('.pergunta');

        this.ready();
    }

    ready() {
        this.questions.forEach((question) => {
            question.addEventListener('click', () => {
                question.classList.toggle('active');
            });
        });
    }
}
if (document.querySelector('.component-faq')) {
    new Faq();
}
